import React from 'react';
import { Link } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';

const SubscriptionCancel: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-2xl">
      <div className="text-center bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-8">
        <CancelIcon 
          className="text-yellow-400 mx-auto mb-4" 
          style={{ fontSize: '4rem' }} 
        />
        <h1 className="text-3xl font-bold text-white mb-2">Subscription Cancelled</h1>
        <p className="text-gray-300 mb-6">
          No worries! Your subscription was not charged and you can try again anytime.
        </p>

        <div className="bg-gray-800 rounded-xl p-6 mb-6">
          <h2 className="text-xl font-semibold text-white mb-4">Why Choose Naia Premium?</h2>
          <div className="space-y-3 text-left">
            <div className="flex items-start gap-3">
              <span className="text-naia-pink mt-0.5 flex-shrink-0">🎵</span>
              <span className="text-gray-300 text-sm">Ad-free streaming with unlimited skips</span>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-naia-pink mt-0.5 flex-shrink-0">📱</span>
              <span className="text-gray-300 text-sm">Download songs for offline listening</span>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-naia-pink mt-0.5 flex-shrink-0">🎧</span>
              <span className="text-gray-300 text-sm">Higher quality audio up to 24-bit/192kHz</span>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-naia-pink mt-0.5 flex-shrink-0">⭐</span>
              <span className="text-gray-300 text-sm">Exclusive content and early access to new features</span>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <Link
            to="/subscription"
            className="inline-block px-6 py-3 bg-naia-pink hover:bg-pink-500 text-white rounded-xl font-medium transition-colors mr-4"
          >
            Try Again
          </Link>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-xl font-medium transition-colors"
          >
            Continue with Free
          </Link>
        </div>

        <div className="mt-8 p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg">
          <h3 className="text-lg font-semibold text-white mb-2">Questions?</h3>
          <p className="text-gray-300 text-sm mb-3">
            We're here to help! If you experienced any issues during checkout or have questions about our plans.
          </p>
          <Link
            to="/support"
            className="text-blue-400 hover:text-blue-300 font-medium text-sm"
          >
            Contact Support →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
